import {
  EVENT_TYPES,
  type BuiltInDispatchEntry
} from '@care-portals/api-interfaces';

/**
 * TMC's `CreateOrder` — the first consumer of built-in dispatch (docs/builtin-dispatch.md).
 * Submits an order to TMC on `order.awaiting_shipment` without a per-org Workflow blueprint.
 */
export const TmcBuiltInDispatch: BuiltInDispatchEntry[] = [
  {
    id: 'tmc-create-order',
    label: 'TMC Pharmacy — Create Order',
    triggerEvent: EVENT_TYPES.awaiting_shipment,
    triggerFilter: { 'assignedPharmacy.name': 'TMC Pharmacy' },
    middlewareHandler: 'tmc',
    functionName: 'CreateOrder',
    integrationFlag: 'isTmcEnabled',
    passPayload: true
  }
];
